import { z } from 'zod';
/**
 * These mirror the Prisma enums. They are duplicated here rather than imported
 * from the generated client so the browser bundle never pulls in server code.
 * The API has a compile-time assertion that the two stay in sync.
 */
export const postTypeSchema = z.enum(['ORIGINAL', 'REPLY', 'REPOST', 'QUOTE']);
export const ingestionSourceSchema = z.enum(['MOCK', 'STREAM', 'WEBHOOK']);
/** Outcome of a single delivered event, as recorded in the ingestion audit log. */
export const ingestionEventStatusSchema = z.enum(['ACCEPTED', 'DUPLICATE', 'FILTERED', 'ERROR']);
export const ingestModeSchema = z.enum(['mock', 'stream', 'webhook', 'off']);
export const connectionStateSchema = z.enum([
    'CONNECTING',
    'CONNECTED',
    'DISCONNECTED',
    'ERROR',
    'IDLE',
]);
export const mediaTypeSchema = z.enum(['photo', 'video', 'animated_gif']);
/** What a post is worth paying attention to, as judged by the model. */
export const postCategorySchema = z.enum([
    'ANECDOTAL',
    'INFORMATION',
    'DRAMA',
    'EMERGENCY',
]);
export const POST_CATEGORY_LABELS = {
    ANECDOTAL: 'ANECDOTAL',
    INFORMATION: 'INFO',
    DRAMA: 'DRAMA',
    EMERGENCY: 'URGENT',
};
/** Ordered least to most pressing — used for sorting and threshold checks. */
export const POST_CATEGORY_RANK = {
    ANECDOTAL: 0,
    INFORMATION: 1,
    DRAMA: 2,
    EMERGENCY: 3,
};
export const digestStatusSchema = z.enum(['PENDING', 'RUNNING', 'READY', 'FAILED']);
export const POST_TYPE_LABELS = {
    ORIGINAL: 'POST',
    REPLY: 'REPLY',
    REPOST: 'REPOST',
    QUOTE: 'QUOTE',
};
//# sourceMappingURL=enums.js.map